module.exports = __webpack_public_path__ + "img/hr-reactor-pipes.8942898c.png";